// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CSS Reset */
/*
  1. Use a more-intuitive box-sizing model.
*/
*,
*::before,
*::after {
  box-sizing: border-box;
}

/*
  2. Remove default margin
*/
* {
  margin: 0;
  padding: 0;
}

/*
  Typographic tweaks!
  3. Add accessible line-height
*/
body {
  line-height: 1.5;
  -webkit-font-smoothing: antialiased;
}

/*
  5. Improve media defaults
*/
img,
picture,
video,
canvas,
svg {
  display: block;
  max-width: 100%;
}

/*
  6. Remove built-in form typography styles
*/
input,
button,
textarea,
select {
  font: inherit;
}

/*
  7. Avoid text overflows
*/
p,
h1,
h2,
h3,
h4,
h5,
h6 {
  overflow-wrap: break-word;
}

/* fonts */
.poppins-extralight {
  font-family: "Poppins", sans-serif;
  font-weight: 200;
  font-style: normal;
}

.poppins-regular {
  font-family: "Poppins", sans-serif;
  font-weight: 400;
  font-style: normal;
}

.poppins-medium {
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  font-style: normal;
}

.poppins-semibold {
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  font-style: normal;
}

.poppins-bold {
  font-family: "Poppins", sans-serif;
  font-weight: 700;
  font-style: normal;
}

.poppins-extrabold {
  font-family: "Poppins", sans-serif;
  font-weight: 800;
  font-style: normal;
}

.poppins-black {
  font-family: "Poppins", sans-serif;
  font-weight: 900;
  font-style: normal;
}

.poppins-regular-italic {
  font-family: "Poppins", sans-serif;
  font-weight: 400;
  font-style: italic;
}

/* Custom properties */
:root {
  --nav-color: #3e2248ff;
  --english-violet: #5b3f64ff;
  --dark-purple-2: #3e2248ff;
  --chinese-violet: #775c7fff;
  --mountbatten-pink: #93799aff;
  --lilac: #b096b6ff;
  --thistle: #ccb3d1ff;
}

/* Navbar */
.navigation-bar {
  background-color: var(--nav-color);
  padding: 12px 16px;
}

.search-box {
  border-radius: 12px;
  border: 1px solid #ffffff1f;
  padding: 4px 16px;
  background-color: var(--english-violet);
  width: 30%;
  display: inline-block;
  margin-right: 8px;
}

.search-box:focus-within {
  background-color: #ffffff0f;
  border: 1px solid #ffffff5f;
}

.search-form {
  width: 100%;
  display: flex;
  align-items: center;
}

#location {
  outline: none;
  background-color: inherit;
  border: none;
  color: #fff;
  flex: 1;
  width: 100%;
}

.btn {
  cursor: pointer;
}

#search-btn {
  border: none;
  color: rgba(255, 255, 255, 1);
}

.toggle-unit {
  border-radius: 12px;
  border: 1px solid #ffffff1f;
  padding: 4px 16px;
  background-color: var(--english-violet);
  color: #fff;
  display: inline;
}

.toggle-unit * {
  margin: 0.5rem;
}

.toggle-unit:hover {
  background-color: #ffffff0f;
  border: 1px solid #ffffff5f;
}

.select-unit {
  font-weight: 700;
  text-decoration: underline;
}

/* Main section */
main {
  background: linear-gradient(
    180deg,
    hsla(284, 36%, 21%, 1) 0%,
    hsla(285, 23%, 32%, 1) 23%,
    hsla(286, 16%, 43%, 1) 72%
  );
  min-height: 95vh;
  max-height: auto;
  padding: 12px 16px;
}

.card {
  background-color: var(--thistle);
  border-radius: 12px;
  padding: 12px 16px;
}

.temp-data {
  font-size: 4rem;
}

.location-icon {
  font-size: 16px;
}

.location-container {
  display: flex;
  align-items: center;
}

.conditions-data {
  font-size: 1.2rem;
}

.main-data-container {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
}

.misc-data {
  display: flex;
  gap: 8px;
  justify-content: space-between;
  margin-top: 16px;
  flex-wrap: wrap;
}

.misc-data > div {
  display: flex;
  flex-direction: column;
}

.data-heading {
  font-weight: 700;
}

.forecast-heading {
  margin: 16px 0 4px;
  color: #fff;
}

.forecast-container {
  display: flex;
  width: 100%;
  gap: 4px;
  overflow-x: auto;
}

.forecast-card {
  background-color: var(--thistle);
  border-radius: 12px;
  padding: 12px 16px;
  flex-shrink: 0;
  margin-bottom: 8px;
  flex-basis: 150px;
}

.forecast-data-container {
  display: flex;
  align-items: center;
  gap: 1rem;
}

/* map component style */
#map {
  height: 250px;
  margin: 16px 0;
  border-radius: 12px;
}

/* loading animation */
.loader {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: block;
  margin: 15px auto;
  position: relative;
  color: #fff;
  left: -100px;
  box-sizing: border-box;
  animation: shadowRolling 2s linear infinite;
}

@keyframes shadowRolling {
  0% {
    box-shadow:
      0px 0 rgba(255, 255, 255, 0),
      0px 0 rgba(255, 255, 255, 0),
      0px 0 rgba(255, 255, 255, 0),
      0px 0 rgba(255, 255, 255, 0);
  }
  12% {
    box-shadow:
      100px 0 white,
      0px 0 rgba(255, 255, 255, 0),
      0px 0 rgba(255, 255, 255, 0),
      0px 0 rgba(255, 255, 255, 0);
  }
  25% {
    box-shadow:
      110px 0 white,
      100px 0 white,
      0px 0 rgba(255, 255, 255, 0),
      0px 0 rgba(255, 255, 255, 0);
  }
  36% {
    box-shadow:
      120px 0 white,
      110px 0 white,
      100px 0 white,
      0px 0 rgba(255, 255, 255, 0);
  }
  50% {
    box-shadow:
      130px 0 white,
      120px 0 white,
      110px 0 white,
      100px 0 white;
  }
  62% {
    box-shadow:
      200px 0 rgba(255, 255, 255, 0),
      130px 0 white,
      120px 0 white,
      110px 0 white;
  }
  75% {
    box-shadow:
      200px 0 rgba(255, 255, 255, 0),
      200px 0 rgba(255, 255, 255, 0),
      130px 0 white,
      120px 0 white;
  }
  87% {
    box-shadow:
      200px 0 rgba(255, 255, 255, 0),
      200px 0 rgba(255, 255, 255, 0),
      200px 0 rgba(255, 255, 255, 0),
      130px 0 white;
  }
  100% {
    box-shadow:
      200px 0 rgba(255, 255, 255, 0),
      200px 0 rgba(255, 255, 255, 0),
      200px 0 rgba(255, 255, 255, 0),
      200px 0 rgba(255, 255, 255, 0);
  }
}
`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAAA,cAAc;AACd;;CAEC;AACD;;;EAGE,sBAAsB;AACxB;;AAEA;;CAEC;AACD;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;;;CAGC;AACD;EACE,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;;CAEC;AACD;;;;;EAKE,cAAc;EACd,eAAe;AACjB;;AAEA;;CAEC;AACD;;;;EAIE,aAAa;AACf;;AAEA;;CAEC;AACD;;;;;;;EAOE,yBAAyB;AAC3B;;AAEA,UAAU;AACV;EACE,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,0BAA0B;EAC1B,2BAA2B;EAC3B,6BAA6B;EAC7B,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA,WAAW;AACX;EACE,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,iBAAiB;EACjB,uCAAuC;EACvC,UAAU;EACV,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,OAAO;EACP,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,iBAAiB;EACjB,uCAAuC;EACvC,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA,iBAAiB;AACjB;EACE;;;;;GAKC;EACD,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;EACX,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,2CAA2C;AAC7C;;AAEA;EACE;IACE;;;;kCAI8B;EAChC;EACA;IACE;;;;kCAI8B;EAChC;EACA;IACE;;;;kCAI8B;EAChC;EACA;IACE;;;;kCAI8B;EAChC;EACA;IACE;;;;mBAIe;EACjB;EACA;IACE;;;;mBAIe;EACjB;EACA;IACE;;;;mBAIe;EACjB;EACA;IACE;;;;mBAIe;EACjB;EACA;IACE;;;;oCAIgC;EAClC;AACF","sourcesContent":["/* CSS Reset */\r\n/*\r\n  1. Use a more-intuitive box-sizing model.\r\n*/\r\n*,\r\n*::before,\r\n*::after {\r\n  box-sizing: border-box;\r\n}\r\n\r\n/*\r\n  2. Remove default margin\r\n*/\r\n* {\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n/*\r\n  Typographic tweaks!\r\n  3. Add accessible line-height\r\n*/\r\nbody {\r\n  line-height: 1.5;\r\n  -webkit-font-smoothing: antialiased;\r\n}\r\n\r\n/*\r\n  5. Improve media defaults\r\n*/\r\nimg,\r\npicture,\r\nvideo,\r\ncanvas,\r\nsvg {\r\n  display: block;\r\n  max-width: 100%;\r\n}\r\n\r\n/*\r\n  6. Remove built-in form typography styles\r\n*/\r\ninput,\r\nbutton,\r\ntextarea,\r\nselect {\r\n  font: inherit;\r\n}\r\n\r\n/*\r\n  7. Avoid text overflows\r\n*/\r\np,\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5,\r\nh6 {\r\n  overflow-wrap: break-word;\r\n}\r\n\r\n/* fonts */\r\n.poppins-extralight {\r\n  font-family: \"Poppins\", sans-serif;\r\n  font-weight: 200;\r\n  font-style: normal;\r\n}\r\n\r\n.poppins-regular {\r\n  font-family: \"Poppins\", sans-serif;\r\n  font-weight: 400;\r\n  font-style: normal;\r\n}\r\n\r\n.poppins-medium {\r\n  font-family: \"Poppins\", sans-serif;\r\n  font-weight: 500;\r\n  font-style: normal;\r\n}\r\n\r\n.poppins-semibold {\r\n  font-family: \"Poppins\", sans-serif;\r\n  font-weight: 600;\r\n  font-style: normal;\r\n}\r\n\r\n.poppins-bold {\r\n  font-family: \"Poppins\", sans-serif;\r\n  font-weight: 700;\r\n  font-style: normal;\r\n}\r\n\r\n.poppins-extrabold {\r\n  font-family: \"Poppins\", sans-serif;\r\n  font-weight: 800;\r\n  font-style: normal;\r\n}\r\n\r\n.poppins-black {\r\n  font-family: \"Poppins\", sans-serif;\r\n  font-weight: 900;\r\n  font-style: normal;\r\n}\r\n\r\n.poppins-regular-italic {\r\n  font-family: \"Poppins\", sans-serif;\r\n  font-weight: 400;\r\n  font-style: italic;\r\n}\r\n\r\n/* Custom properties */\r\n:root {\r\n  --nav-color: #3e2248ff;\r\n  --english-violet: #5b3f64ff;\r\n  --dark-purple-2: #3e2248ff;\r\n  --chinese-violet: #775c7fff;\r\n  --mountbatten-pink: #93799aff;\r\n  --lilac: #b096b6ff;\r\n  --thistle: #ccb3d1ff;\r\n}\r\n\r\n/* Navbar */\r\n.navigation-bar {\r\n  background-color: var(--nav-color);\r\n  padding: 12px 16px;\r\n}\r\n\r\n.search-box {\r\n  border-radius: 12px;\r\n  border: 1px solid #ffffff1f;\r\n  padding: 4px 16px;\r\n  background-color: var(--english-violet);\r\n  width: 30%;\r\n  display: inline-block;\r\n  margin-right: 8px;\r\n}\r\n\r\n.search-box:focus-within {\r\n  background-color: #ffffff0f;\r\n  border: 1px solid #ffffff5f;\r\n}\r\n\r\n.search-form {\r\n  width: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n#location {\r\n  outline: none;\r\n  background-color: inherit;\r\n  border: none;\r\n  color: #fff;\r\n  flex: 1;\r\n  width: 100%;\r\n}\r\n\r\n.btn {\r\n  cursor: pointer;\r\n}\r\n\r\n#search-btn {\r\n  border: none;\r\n  color: rgba(255, 255, 255, 1);\r\n}\r\n\r\n.toggle-unit {\r\n  border-radius: 12px;\r\n  border: 1px solid #ffffff1f;\r\n  padding: 4px 16px;\r\n  background-color: var(--english-violet);\r\n  color: #fff;\r\n  display: inline;\r\n}\r\n\r\n.toggle-unit * {\r\n  margin: 0.5rem;\r\n}\r\n\r\n.toggle-unit:hover {\r\n  background-color: #ffffff0f;\r\n  border: 1px solid #ffffff5f;\r\n}\r\n\r\n.select-unit {\r\n  font-weight: 700;\r\n  text-decoration: underline;\r\n}\r\n\r\n/* Main section */\r\nmain {\r\n  background: linear-gradient(\r\n    180deg,\r\n    hsla(284, 36%, 21%, 1) 0%,\r\n    hsla(285, 23%, 32%, 1) 23%,\r\n    hsla(286, 16%, 43%, 1) 72%\r\n  );\r\n  min-height: 95vh;\r\n  max-height: auto;\r\n  padding: 12px 16px;\r\n}\r\n\r\n.card {\r\n  background-color: var(--thistle);\r\n  border-radius: 12px;\r\n  padding: 12px 16px;\r\n}\r\n\r\n.temp-data {\r\n  font-size: 4rem;\r\n}\r\n\r\n.location-icon {\r\n  font-size: 16px;\r\n}\r\n\r\n.location-container {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.conditions-data {\r\n  font-size: 1.2rem;\r\n}\r\n\r\n.main-data-container {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 1rem;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.misc-data {\r\n  display: flex;\r\n  gap: 8px;\r\n  justify-content: space-between;\r\n  margin-top: 16px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.misc-data > div {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.data-heading {\r\n  font-weight: 700;\r\n}\r\n\r\n.forecast-heading {\r\n  margin: 16px 0 4px;\r\n  color: #fff;\r\n}\r\n\r\n.forecast-container {\r\n  display: flex;\r\n  width: 100%;\r\n  gap: 4px;\r\n  overflow-x: auto;\r\n}\r\n\r\n.forecast-card {\r\n  background-color: var(--thistle);\r\n  border-radius: 12px;\r\n  padding: 12px 16px;\r\n  flex-shrink: 0;\r\n  margin-bottom: 8px;\r\n  flex-basis: 150px;\r\n}\r\n\r\n.forecast-data-container {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 1rem;\r\n}\r\n\r\n/* map component style */\r\n#map {\r\n  height: 250px;\r\n  margin: 16px 0;\r\n  border-radius: 12px;\r\n}\r\n\r\n/* loading animation */\r\n.loader {\r\n  width: 10px;\r\n  height: 10px;\r\n  border-radius: 50%;\r\n  display: block;\r\n  margin: 15px auto;\r\n  position: relative;\r\n  color: #fff;\r\n  left: -100px;\r\n  box-sizing: border-box;\r\n  animation: shadowRolling 2s linear infinite;\r\n}\r\n\r\n@keyframes shadowRolling {\r\n  0% {\r\n    box-shadow:\r\n      0px 0 rgba(255, 255, 255, 0),\r\n      0px 0 rgba(255, 255, 255, 0),\r\n      0px 0 rgba(255, 255, 255, 0),\r\n      0px 0 rgba(255, 255, 255, 0);\r\n  }\r\n  12% {\r\n    box-shadow:\r\n      100px 0 white,\r\n      0px 0 rgba(255, 255, 255, 0),\r\n      0px 0 rgba(255, 255, 255, 0),\r\n      0px 0 rgba(255, 255, 255, 0);\r\n  }\r\n  25% {\r\n    box-shadow:\r\n      110px 0 white,\r\n      100px 0 white,\r\n      0px 0 rgba(255, 255, 255, 0),\r\n      0px 0 rgba(255, 255, 255, 0);\r\n  }\r\n  36% {\r\n    box-shadow:\r\n      120px 0 white,\r\n      110px 0 white,\r\n      100px 0 white,\r\n      0px 0 rgba(255, 255, 255, 0);\r\n  }\r\n  50% {\r\n    box-shadow:\r\n      130px 0 white,\r\n      120px 0 white,\r\n      110px 0 white,\r\n      100px 0 white;\r\n  }\r\n  62% {\r\n    box-shadow:\r\n      200px 0 rgba(255, 255, 255, 0),\r\n      130px 0 white,\r\n      120px 0 white,\r\n      110px 0 white;\r\n  }\r\n  75% {\r\n    box-shadow:\r\n      200px 0 rgba(255, 255, 255, 0),\r\n      200px 0 rgba(255, 255, 255, 0),\r\n      130px 0 white,\r\n      120px 0 white;\r\n  }\r\n  87% {\r\n    box-shadow:\r\n      200px 0 rgba(255, 255, 255, 0),\r\n      200px 0 rgba(255, 255, 255, 0),\r\n      200px 0 rgba(255, 255, 255, 0),\r\n      130px 0 white;\r\n  }\r\n  100% {\r\n    box-shadow:\r\n      200px 0 rgba(255, 255, 255, 0),\r\n      200px 0 rgba(255, 255, 255, 0),\r\n      200px 0 rgba(255, 255, 255, 0),\r\n      200px 0 rgba(255, 255, 255, 0);\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
